import { TemplatePage } from './types';

const halloweenPage: TemplatePage = {
  header: {
    color: '#E7CEB8',
    icon: 'images/video-templates/halloween.jpg',
    title: 'Halloween Video Templates Collection',
    title_meta: '50+ Free Customizable Halloween Video Templates',
    description_meta:
      "Kickstart your business's spooky season craze with Wave.video’s 50+ easily customizable Halloween video " +
      'templates.',
    description:
      "Kickstart your business's spooky season craze with these easily customizable Halloween video templates. " +
      'Maximize the potential of Halloween for your business by creating fang-tastic marketing videos in minutes.'
  },
  footer: {
    category: 'halloween',
    description:
      'With Wave.video’s wide selection of Halloween video templates, you will easily create hair-raising ' +
      'marketing videos for your website, social media, email newsletter, or blog. All templates are free ' +
      'and easy to customize to adhere to your brand’s needs.'
  },
  content: [
    {
      type: 'templates',
      title: 'Halloween Video Templates',
      search: {
        category: '/Holidays & Occasions/Halloween'
      }
    },
    {
      type: 'stocks',
      title: 'Halloween',
      search: {
        name: 'halloween'
      }
    },
    { type: 'calendar' }
  ]
};

export default halloweenPage;
